<template>
  <section
    id="merit"
    class="co-bg-striped px-5 py-20"
  >
    <div class="co-container-lg">
      <h2 class="co-heading-2-caption mb-6 text-center">
        コースの特長
      </h2>
      <div class="mb-12 text-left text-co-gray-600 md:text-center">
        「目標に合わせた最適な学習をしたい」「本当に必要なことだけを学びたい」<br class="hidden md:block">そんなあなたの願いを叶える専用学習プラン
      </div>
      <div class="flex flex-col gap-9 md:flex-row">
        <div class="w-full">
          <img
            src="~/assets/images/Te/TeCourse/Ordermade/Merit/merit-study.svg"
            width="376"
            height="211"
            class="mb-5 w-full"
            alt="学習内容を選べる"
          >
          <h3 class="co-display-8 mb-2 text-center font-bold leading-normal">
            学習内容が自由に選べる
          </h3>
          <div class="text-co-gray-600">
            20種類以上のコースを組み合わせあなたに合ったプランをご提案。
          </div>
        </div>
        <div class="w-full">
          <img
            src="~/assets/images/Te/TeCourse/Ordermade/Merit/merit-time.svg"
            width="376"
            height="211"
            class="mb-5 w-full"
            alt="学習期間が自分に合わせられる"
          >
          <h3 class="co-display-8 mb-2 text-center font-bold leading-normal">
            学習期間が自分に合わせられる
          </h3>
          <div class="text-co-gray-600">
            一人ひとりのライフスタイルに合わせた無理のない学習計画をご提案いたします。
          </div>
        </div>
        <div class="w-full">
          <img
            src="~/assets/images/Te/TeCourse/Ordermade/Merit/merit-price.svg"
            width="376"
            height="211"
            class="mb-5 w-full"
            alt="受講料が節約できる"
          >
          <h3 class="co-display-8 mb-2 text-center font-bold leading-normal">
            受講料が節約できる
          </h3>
          <div class="text-co-gray-600">
            ご予算に合わせた学習のご案内、お支払い方法や補助金のご利用等、無駄のないご提案をいたします。
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<style scoped>
</style>
